// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/expert_card/highlight_type.proto" (package "bianka.enums.expert_card", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.expert_card.HighlightType
 */
export enum HighlightType {
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_WORKED_WITH_YOUR_TEAM = 1;
     */
    WORKED_WITH_YOUR_TEAM = 1,
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_WORKED_WITH_CLIENTS_IN_INDUSTRY = 2;
     */
    WORKED_WITH_CLIENTS_IN_INDUSTRY = 2,
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_SAVED_BY_TEAM_MEMBER = 3;
     */
    SAVED_BY_TEAM_MEMBER = 3,
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_BUYERS_KEEP_COMING_BACK = 4;
     */
    BUYERS_KEEP_COMING_BACK = 4,
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_HIGHLY_RESPONSIVE = 5;
     */
    HIGHLY_RESPONSIVE = 5,
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_SELLER_SPEAKS = 6;
     */
    SELLER_SPEAKS = 6,
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_UNAVAILABLE_UNTIL = 7;
     */
    UNAVAILABLE_UNTIL = 7,
    /**
     * @generated from protobuf enum value: HIGHLIGHT_TYPE_NO_LONGER_ACTIVE = 8;
     */
    NO_LONGER_ACTIVE = 8
}
